import { useEffect, useState } from 'react'
import { api } from '../../../infrastructure/api'
import { createContainer } from 'unstated-next'
import guid from '../../../infrastructure/guid'


function useComment() {
    let [demandingKeys, setDemandingKeys] = useState<string[]>([])
    let [loadingKeys, setLoadingKeys] = useState<string[]>([])
    let [loadedKeys, setLoadedKeys] = useState<string[]>([])
    let [existingKeys, setExistingKeys] = useState<Set<string>>(new Set())

    useEffect(function startLoadNextBatchOnNewDemandOrPreviousBatchEnded() {
        if (demandingKeys.length) {
            load()
        }
    }, [demandingKeys, loadingKeys])

    useEffect(function exposeLoadedKeysWhenAllBatchsAreLoaded() {
        if (!demandingKeys.length && !loadingKeys.length)
            setExistingKeys(previous => new Set([...previous, ...loadedKeys]))
    }, [loadingKeys])

    let exists = async (associationKey: string) => {
        if (!associationKey || existingKeys.has(associationKey)) return
        setDemandingKeys(previous => [...previous, associationKey])
    }

    let load = async () => {
        if (loadingKeys.length) return

        let nextKeys = demandingKeys
        setLoadingKeys(nextKeys)
        setDemandingKeys([])

        try {
            var postResult = await api.post('comment/existence', { associationKeys: nextKeys }, { correlationId: guid.createNew() })
            let result = await api.get<string[]>(`comment/existence?correlationId= ${postResult.correlationId}`)
            setLoadedKeys(previous => [...new Set([...previous, ...result])])
            setExistingKeys(previous => new Set([...previous, ...result]))
        } catch (err) {
            throw err
        } finally {
            setLoadingKeys([])
        }
    }

    let addExistence = (associationKey: string) =>
        setExistingKeys(previous => new Set(previous).add(associationKey))

    let convertContentTextToHTMLString = (content: string) => {
        if (!content) return ''

        try {
            const parsedContent = JSON.parse(content)
            if (parsedContent.blocks) {
                let html = ''
                parsedContent.blocks.forEach((block: any) => {
                    if (block.text) {
                        html += `<p>${block.text}</p>`
                    }
                })
                return html
            }
        } catch (err) {
            return `<p>${content}</p>`
        }

        return content
    }

    return { existingKeys, exists, addExistence, convertContentTextToHTMLString }
}

export let CommentContainer = createContainer(useComment)